import { Outlet } from '@tanstack/react-router'
import { MoreHorizontalIcon, PlusCircle } from 'lucide-react'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { RegisterCaseDialogContext } from './context'
import { useApplicantCasesLayout } from './hook/use-applicant-cases-layout'
import { ApplicantCases } from './ui/applicant-cases/applicant-cases'
import { CaseViewTabs } from './ui/applicant-cases/case-view-tabs/case-view-tabs'
import { CategoryDeleteDialog } from './ui/applicant-cases/category-delete-dialog/category-delete-dialog'
import { CategoryTabs } from './ui/applicant-cases/category-tabs/category-tabs'
import { ApplicantInfo } from './ui/applicant-info/applicant-info'
import { RegisterCaseDialog } from './ui/case-dialogs/register/register-case-dialog'

export const ApplicantCasesLayout = () => {
  const {
    currentCaseViewTab,
    currentCategoryTab,
    applicantId,
    dataApplicant,
    dataListCategory,
    isRegisterCaseDialogOpen,
    isCategoryDeleteDialogOpen,
    openCategoryDeleteDialog,
    closeRegisterCaseDialog,
    closeCategoryDeleteDialog,
    handleInvalidate,
    handleChangeCaseViewTab,
    handleChangeCategoryTab,
    handleAddCaseClick,
    handleCaseAdded,
  } = useApplicantCasesLayout()

  if (!dataApplicant) {
    return null
  }

  return (
    <>
      <div className="flex h-full w-full">
        <div className="flex-1 overflow-auto px-10 py-11">
          <ApplicantInfo applicant={dataApplicant} onInvalidate={handleInvalidate} />

          <div className={cn('mb-2 mt-4', 'flex items-center justify-between')}>
            <CaseViewTabs value={currentCaseViewTab} onChange={handleChangeCaseViewTab} />
            <Button onClick={handleAddCaseClick}>
              <PlusCircle className="mr-2" size={16} />
              Add Case
            </Button>
          </div>

          <div className={cn('flex items-center justify-between', 'mb-[-75px]')}>
            <div className={cn('flex', 'mb-6 mt-5')}>
              <CategoryTabs
                value={currentCategoryTab}
                pathId={applicantId}
                tabs={dataListCategory ?? []}
                onChange={handleChangeCategoryTab}
              />
              <Button className={cn('ml-5')} variant="secondary" size="icon" onClick={openCategoryDeleteDialog}>
                <MoreHorizontalIcon size={24} />
              </Button>
            </div>
          </div>

          <ApplicantCases
            hideApplicant
            isEoir={currentCaseViewTab === 'eoir'}
            currentCategoryTab={currentCategoryTab}
          />
        </div>

        {/* Case Detail */}
        <Outlet />
      </div>

      {/* Dialogs */}
      <RegisterCaseDialogContext.Provider value={{ closeDialog: closeRegisterCaseDialog }}>
        <RegisterCaseDialog open={isRegisterCaseDialogOpen} onRegistered={handleCaseAdded} />
      </RegisterCaseDialogContext.Provider>

      <CategoryDeleteDialog open={isCategoryDeleteDialogOpen} onClose={closeCategoryDeleteDialog} />
    </>
  )
}
